import React from "react";

import { withShowIf } from "../../with-show-if/with-show-If.component";

import { LoaderMessageProps } from "./loader-message.props";
import { StyledTypography } from "./loader-message.styles";

export const LoaderMessage = withShowIf((props: LoaderMessageProps) => (
  <StyledTypography variant="h5">{props.message}</StyledTypography>
));
